<div *ngIf="isLoading">Loading Account List...</div>

<select *ngIf="!isLoading" [compareWith]="byId" class="form-control" name="account"
        [(ngModel)]="model.account" [required]="required">
  <option *ngFor="let singleAccountType of accounts" [ngValue]="singleAccountType.id">{{ singleAccountType.name }}
  </option>
</select>
